export const randomArbitrary = (min, max) => {
    return Math.random() * (max - min) + min;
};
export const random = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
export const clamp = (num, min, max) => {
    return Math.min(Math.max(num, min), max);
};
export const roundToDecimal = (value = 0, decimals = 0) => {
    return parseFloat((value).toFixed(decimals));
};
export const decimals = (num) => {
    const text = num.toString();
    if (text.indexOf('e-') > -1) {
        const [base, trail] = text.split('e-');
        const elen = parseInt(trail, 10);
        const idx = base.indexOf('.');
        return idx === -1 ? (elen) : (base.length - idx - 1) + elen;
    }
    const index = text.indexOf('.');
    return index === -1 ? 0 : (text.length - index - 1);
};
export const percentWithinRange = (input, min, max) => {
    if (isNaN(input) || isNaN(min) || isNaN(max))
        return undefined;
    return ((input - min) * 100) / (max - min);
};
export const valueWithinRange = (percent, min, max) => {
    if (isNaN(percent) || isNaN(min) || isNaN(max))
        return undefined;
    return ((percent * (max - min) / 100) + min);
};
export const floatsWithinRange = (numA, numB, range) => {
    if (isNaN(numA) || isNaN(numB) || isNaN(range))
        return undefined;
    return Math.abs(numA - numB) <= range;
};
